import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { type RunState } from "types/generated";

import { buildBulkRunStatesQuery, type StacksBulkActionsResultsTriggeredRunsData, type RunToPoll } from "./gql";

export type PolledRunState = {
  state: RunState;
};

const useStacksBulkActionsResultsRunStatesPolling = (runs: RunToPoll[], enabled: boolean) => {
  const query = buildBulkRunStatesQuery(runs);

  const { data } = usePolledQuery<StacksBulkActionsResultsTriggeredRunsData>(query, {
    skip: !enabled,
    pollingGroup: PollingIntervalGroups.Default,
    shouldPoll: (data) => {
      if (!data) return true;
      // continue polling until all runs are finished
      return runs.some((_, i) => !data[`stack_${i}`]?.run?.finished);
    },
  });

  const runStates = useMemo(() => {
    if (!data) return undefined;

    const map = new Map<string, PolledRunState>();

    runs.forEach((run, i) => {
      const runData = data[`stack_${i}`]?.run;
      if (runData) {
        map.set(run.runId, { state: runData.state });
      }
    });

    return map;
  }, [data, runs]);

  return { runStates };
};

export default useStacksBulkActionsResultsRunStatesPolling;
